module.exports = __webpack_public_path__ + "./fonts/fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/fontawesome-webfont.eot?v=4.6.3
// module id = 13
// module chunks = 0